import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import PeriodRow from '../PeriodRow';
import useCommonDetails from '../../../hooks/useCommonDetails';
interface Comment {
  role: string;
  name: string;
  comment: string;
  addedAt: string; // or Date if you prefer
}
function GameRow(props: {
  gameData?: any;
  periodList: any;
  userInfo: any;
  handleApiToggle: any;
  fetchGamesList: any;
  isPeriodOnly: boolean;
}) {
  const {
    periodList,
    handleApiToggle,
    userInfo,
    fetchGamesList,
    gameData,
    isPeriodOnly,
  } = props;
  const currentUserInfo = useCommonDetails();

  return (
    <Box>
      {' '}
      <TableContainer component={Paper}>
        {periodList?.length > 0 ? (
          <Table size="small" aria-label="periods">
            <TableHead>
              <TableRow>
                <TableCell align="left">Period ID</TableCell>
                <TableCell align="left">Period</TableCell>

                <TableCell align="left">Game ID</TableCell>
                <TableCell align="left" sx={{ minWidth: 130 }}>
                  Assign At
                </TableCell>

                <TableCell align="left">Assign</TableCell>

                {isPeriodOnly && (
                  <TableCell align="left" sx={{ minWidth: 120 }}>
                    Comments
                  </TableCell>
                )}
                <TableCell align="left">Time Tack</TableCell>
                <TableCell align="left">Timer</TableCell>

                <TableCell align="left">Ratting</TableCell>

                <TableCell align="left" sx={{ minWidth: 310 }}>
                  Progress
                </TableCell>

                <TableCell align="left">Status</TableCell>
                <TableCell align="left" sx={{ minWidth: 120 }}>
                  Files
                </TableCell>
                <TableCell align="left" sx={{ minWidth: 120 }}>
                  Copmleted Status
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {periodList.map((period: any, index: any) => (
                <PeriodRow
                  key={index}
                  period={period}
                  gameData={gameData}
                  currentUserInfo={currentUserInfo}
                  userInfo={userInfo}
                  handleApiToggle={handleApiToggle}
                  fetchGamesList={fetchGamesList}
                  isPeriodOnly={isPeriodOnly}
                ></PeriodRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No periods found.</Typography>
        )}
      </TableContainer>
    </Box>
  );
}

export default GameRow;
